import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import PageScrollTop from './components/pageToTop/PageScrollTop'

// Views import Here
import Home from "./views/Home";
import WebDesign from "./views/WebDesign";

// Import Css Here 
import './assets/scss/style.scss';
import ContactUs from "./views/ContactUs";
import WebDevelopment from "./views/WebDevelopment";
import AboutUs from "./pages/AboutUs";
import AndroidApps from "./views/AndroidApps";
import IosApps from "./views/IosApps";
import CsmsDevelopment from "./views/CsmsDevelopment"
import BulkSMS from "./views/BulkSMS";
import Ecommerce from "./views/ecommerce";
import DigitalMarketing from "./views/DigitalMarketing"
import SearchEngineOptimization from "./views/SearchEngineOptimization"
import PaymentIntegration from "./views/PaymentIntegration"
import USSD from "./views/USSD"



const App = () => {
    return (
        <Router>
            <PageScrollTop>
                <Switch>
                    <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={Home}/>
                    <Route path={`${process.env.PUBLIC_URL + "/web/web-design"}`} exact component={WebDesign}/>
                    <Route path={`${process.env.PUBLIC_URL + "/about-us"}`} exact component={AboutUs}/>
                    <Route path={`${process.env.PUBLIC_URL + "/mobile/android-apps"}`} exact component={AndroidApps}/>
                    <Route path={`${process.env.PUBLIC_URL + "/mobile/ios-apps"}`} exact component={IosApps}/>
                    <Route path={`${process.env.PUBLIC_URL + "/mobile/ussd"}`} exact component={USSD}/>
                    <Route path={`${process.env.PUBLIC_URL + "/marketing/bulk-sms"}`} exact component={BulkSMS}/>
                    <Route path={`${process.env.PUBLIC_URL + "/business/ecommerce"}`} exact component={Ecommerce}/>
                    <Route path={`${process.env.PUBLIC_URL + "/business/payment-integration"}`} exact component={PaymentIntegration}/>
                    <Route path={`${process.env.PUBLIC_URL + "/marketing/digital-marketing"}`} exact component={DigitalMarketing}/>
                    <Route path={`${process.env.PUBLIC_URL + "/marketing/search-engine-optimization"}`} exact component={SearchEngineOptimization}/>
                    <Route path={`${process.env.PUBLIC_URL + "/business/cms-development"}`} exact component={CsmsDevelopment}/>
                    <Route path={`${process.env.PUBLIC_URL + "/web/web-app-development"}`} exact component={WebDevelopment}/>
                    <Route path={`${process.env.PUBLIC_URL + "/contact-us"}`} exact component={ContactUs}/>
                </Switch>
            </PageScrollTop>
        </Router>
    )
}


export default App
